// @flow
import React from 'react'
import { FormField, StyledField, StyledSelect, Label, Error } from 'src/components/Form'
import type { Field as FieldProps } from 'src/types'

const renderNativeSelect = ({
  className,
  input,
  label,
  type,
  options,
  placeholder,
  autocomplete,
  isInitPage,
  useFull,
  meta: { touched, error }
}: FieldProps) => (
  <FormField className={className} isInitPage={isInitPage}>
    <Label>{label}</Label>
    <StyledField isInitPage={isInitPage} hasError={touched && error}>
      <StyledSelect {...input} onBlur={e => input.onBlur(undefined)} value={input.value}>
        {options && options.length > 0 && <option value="">Please select...</option>}
        {options &&
          options.map(option => (
            <option
              key={option.value}
              name={option.value}
              value={useFull ? JSON.stringify(option) : option.value}
            >
              {option.label}
            </option>
          ))}
      </StyledSelect>
      {touched && error && (
        <Error>Oh, you need to select {`${label}`.toLowerCase()} to continue</Error>
      )}
    </StyledField>
  </FormField>
)

export default renderNativeSelect



// WEBPACK FOOTER //
// ./src/helpers/fieldRenderers/NativeSelect.js